import { FC } from "react";
import styles from "./Form.module.scss";

const FormHeadline: FC = () => {
    return <h2 className={styles.headline}>Checker whale</h2>;
};

export default FormHeadline;
